import React from 'react';
import { Link } from 'react-router-dom';
var TiTroviIn = function TiTroviIn(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "breadcrumb-title"
  }, "Ti trovi in:"), /*#__PURE__*/React.createElement("ol", {
    className: "breadcrumb"
  }, children.map(function (dati) {
    return /*#__PURE__*/React.createElement("li", {
      className: "breadcrumb-item",
      key: dati.to
    }, /*#__PURE__*/React.createElement(Link, {
      key: dati.to,
      to: {
        pathname: dati.to,
        state: dati.state
      }
    }, dati.label));
  }), props.title ? /*#__PURE__*/React.createElement("li", {
    className: "breadcrumb-item",
    key: 'page'
  }, /*#__PURE__*/React.createElement("strong", {
    key: 'page'
  }, props.title)) : null));
};
export default TiTroviIn;